/*
  BNH — Model şeridi davranışı.

  Şerit sunucuda basılıyor (snippets/bnh-model-strip.liquid); burada
  yalnızca seçim, sayım ve kaydırma var.

  Notlar:
  - Filtre tarayıcıda çalışıyor: koleksiyonlar küçük, kartların hepsi
    zaten sayfada. Sayfa yenilenmiyor.
  - Seçim adres çubuğuna ?model=<handle> olarak yazılıyor; bağlantı
    paylaşılabilir ve geri tuşu çalışır.
  - Renk/beden filtreleri ızgarayı AJAX ile yeniden basıyor. Izgara
    değiştiğinde seçim yeniden uygulanıyor, boş kalan modeller
    gizleniyor.
*/
(function () {
  var PARAM = 'model';

  function define() {
    if (window.customElements && customElements.get('nb-model-strip')) return;

    class NBModelStrip extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bnh-models__track');
        this.chips = Array.prototype.slice.call(this.querySelectorAll('.bnh-models__chip'));
        this.navs = Array.prototype.slice.call(this.querySelectorAll('.bnh-models__nav'));
        if (!this.track || !this.chips.length) return;

        this.chips.forEach(function (chip) {
          chip.addEventListener('click', this.onChip.bind(this, chip));
        }.bind(this));

        this.navs.forEach(function (nav) {
          nav.addEventListener('click', function () {
            var step = this.track.clientWidth * 0.7;
            this.track.scrollBy({
              left: step * parseInt(nav.dataset.dir, 10),
              behavior: 'smooth'
            });
          }.bind(this));
        }.bind(this));

        this.track.addEventListener('scroll', this.updateNavs.bind(this), { passive: true });
        window.addEventListener('resize', this.updateNavs.bind(this), { passive: true });
        window.addEventListener('popstate', function () {
          this.apply(this.fromUrl(), false);
        }.bind(this));

        this.watchGrid();
        this.apply(this.fromUrl(), false);
        this.updateNavs();
      }

      /* --- yardımcılar --- */

      grid() {
        return document.getElementById('product-grid');
      }

      cards() {
        var grid = this.grid();
        return grid
          ? Array.prototype.slice.call(grid.querySelectorAll('.grid__item[data-nb-product]'))
          : [];
      }

      fromUrl() {
        try {
          return new URL(window.location.href).searchParams.get(PARAM) || '';
        } catch (e) {
          return '';
        }
      }

      /* --- seçim --- */

      onChip(chip, event) {
        event.preventDefault();
        var next = chip.dataset.model === this.current ? '' : chip.dataset.model;
        this.apply(next, true);
      }

      apply(model, push) {
        var cards = this.cards();
        if (!cards.length) return;

        /* Adreste kalan geçersiz bir model tüm ızgarayı boşaltmasın. */
        if (model) {
          var exists = cards.some(function (c) {
            return c.dataset.nbProduct === model;
          });
          if (!exists) model = '';
        }

        this.current = model;

        cards.forEach(function (card) {
          var show = !model || card.dataset.nbProduct === model;
          card.classList.toggle('nb-model-hidden', !show);
        });

        this.chips.forEach(function (chip) {
          var on = (chip.dataset.model || '') === model;
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        this.syncCount(cards, model);
        this.recount(cards);

        if (push) {
          this.writeUrl(model);
          var active = this.querySelector('.bnh-models__chip.is-active');
          if (active) active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      }

      writeUrl(model) {
        try {
          var url = new URL(window.location.href);
          if (model) {
            url.searchParams.set(PARAM, model);
          } else {
            url.searchParams.delete(PARAM);
          }
          window.history.pushState({ nbModel: model }, '', url.toString());
        } catch (e) {
          /* eski tarayıcı: adres güncellenmese de filtre çalışır */
        }
      }

      /* Başlıktaki "6 ürün" sayacı bir model seçilince yanıltıcı olur. */
      syncCount(cards, model) {
        var visible = cards.filter(function (c) {
          return !c.classList.contains('nb-model-hidden');
        }).length;

        document.querySelectorAll('.product-count__text').forEach(function (el) {
          if (!el.dataset.nbOriginal) el.dataset.nbOriginal = el.textContent.trim();
          el.textContent = model ? visible + ' seçenek' : el.dataset.nbOriginal;
        });
      }

      /* Renk filtresi bir modeli tamamen elediyse o düğmeyi gizle. */
      recount(cards) {
        var counts = {};
        cards.forEach(function (c) {
          counts[c.dataset.nbProduct] = (counts[c.dataset.nbProduct] || 0) + 1;
        });
        this.chips.forEach(function (chip) {
          var key = chip.dataset.model;
          if (!key) return;
          chip.hidden = !counts[key];
        });
      }

      /* --- ızgara AJAX ile yenilendiğinde --- */

      watchGrid() {
        var host = document.getElementById('ProductGridContainer');
        if (!host || this.observer) return;
        this.observer = new MutationObserver(function () {
          clearTimeout(this.reapplyTimer);
          this.reapplyTimer = setTimeout(function () {
            this.apply(this.current || this.fromUrl(), false);
          }.bind(this), 60);
        }.bind(this));
        this.observer.observe(host, { childList: true, subtree: true });
      }

      /* --- oklar --- */

      updateNavs() {
        if (!this.track) return;
        requestAnimationFrame(function () {
          var overflow = this.track.scrollWidth - this.track.clientWidth;
          var x = this.track.scrollLeft;
          var scrollable = overflow >= 8;
          var prev = this.querySelector('.bnh-models__nav--prev');
          var next = this.querySelector('.bnh-models__nav--next');
          /* Oklar taşma varken hep dursun; uçlarda yalnızca sönükleşsin,
             yoksa şerit her kaydırmada yerinden oynuyor. */
          if (prev) {
            prev.hidden = !scrollable;
            prev.disabled = x <= 4;
          }
          if (next) {
            next.hidden = !scrollable;
            next.disabled = x >= overflow - 4;
          }
          this.classList.toggle('bnh-models--overflow', scrollable);
        }.bind(this));
      }
    }

    customElements.define('nb-model-strip', NBModelStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', define);
  } else {
    define();
  }
})();
